import React from 'react';
import { Button, Card, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaCheckCircle } from 'react-icons/fa';

export default function Success() {
    return (
        <div style={{ minHeight: 'calc(100vh - 281px)', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <Container className="d-flex flex-column align-items-center">
                <Card style={{ width: '22rem', textAlign: 'center', padding: '20px', borderRadius: '10px', boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)' }}>
                    <FaCheckCircle size={60} color="green" />
                    <Card.Body>
                        <Card.Title style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>¡Pago aprobado!</Card.Title>
                        <Card.Text style={{ color: '#555' }}>
                            Tu pago ha sido procesado con éxito. Gracias por tu compra.  
                            En breve recibirás un mensaje en tu correo con más detalles.
                        </Card.Text>
                        <Button variant="success" as={Link} to="/">Volver al inicio</Button>
                    </Card.Body>
                </Card>
            </Container>
        </div>
    );
}
